var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepartment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14.0625H13.5V2.34375C13.5 1.56738 12.7441 0.9375 11.8125 0.9375H6.1875C5.25586 0.9375 4.5 1.56738 4.5 2.34375V14.0625ZM6.75 2.8125H11.25V3.75H6.75V2.8125ZM18 5.15625V12.6562C18 13.4326 17.2441 14.0625 16.3125 14.0625H14.625V3.75H16.3125C17.2441 3.75 18 4.37988 18 5.15625ZM3.375 14.0625H1.6875C0.755859 14.0625 0 13.4326 0 12.6562V5.15625C0 4.37988 0.755859 3.75 1.6875 3.75H3.375V14.0625Z",
    fill: "#FF0990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.b28d12be98ad23fe332b39f2581781d5.svg";
export { ForwardRef as ReactComponent };